@if (currentUser$ | async; as currentUser) {
  <div class="profile profile_edit border-radius">
    <div class="profile__avatar border-radius">
      <img
        [src]="currentUser.avatar?.url || 'assets/no-avatar.svg'"
        [width]="currentUser.avatar ? currentUser.avatar.width : 100"
        [height]="currentUser.avatar ? currentUser.avatar.height : 100"
        [alt]="currentUser.avatar ? 'User Avatar' : 'No Avatar'"
      />
    </div>
    <div class="profile__info">
      <div>
        @if (getUserName(currentUser); as userName) {
          <div class="heading heading_small">
            {{ userName }}
          </div>
        }

        <div class="profile__line">
          <div>E-mail:</div>
          <div>
            <span>{{ currentUser.email }}</span>
          </div>
        </div>

        @if (currentUser.phone) {
          <div class="profile__line">
            <div>Phone:</div>
            <div>{{ currentUser.phone }}</div>
          </div>
        }

        @if (getAddress(currentUser); as address) {
          <div class="profile__line">
            <div>Address:</div>
            <div [innerHTML]="address"></div>
            <!-- Sarkandaugavas iela 3-47, LV-1005, <br />Riga, Latvia -->
          </div>
        }
      </div>
    </div>

    <div class="account__more account__more_profile">
      <a
        routerLink="profile"
        class="button button_dark button_standard account__buttons"
      >
        Edit profile
      </a>

      <a
        routerLink="change-password"
        class="button button_dark button_standard account__buttons"
      >
        Change Password
      </a>

      <div class="account__logout">
        <div appLogout>
          <img
            src="assets/icon-logout.svg"
            width="512"
            height="512"
            alt="Logout"
          />
          <span>Logout</span>
        </div>
      </div>
    </div>
  </div>
}
